import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';

const useInsertApplication = () => {
  const { enqueueSnackbar } = useSnackbar();

  const insertRequest = (
    getApplicationList,
    setIsInsertModalOpen,
    setInsertLoading,
    payload,
  ) => {
    axiosClient
      .post(`/SettingSystem/Application/Insert`, {
        name: payload.name,
        key: payload.key,
      })
      .then(res => {
        if (res.status === 200) {
          enqueueSnackbar(`افزودن با موفقیت انجام شد`, { variant: 'success' });
          getApplicationList();
          setIsInsertModalOpen(false);
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => {
        console.log(err);
        enqueueSnackbar(err?.message, { variant: 'error' });
      })
      .finally(() => setInsertLoading(false));
  };
  return [insertRequest];
};

export default useInsertApplication;
